import * as Yup from "yup";

export const stationsOpenRequestSchema = Yup.object().shape({
  token: Yup.string().required(),
});

export type StationsOpenRequest = Yup.InferType<
  typeof stationsOpenRequestSchema
>;
